// extracted by mini-css-extract-plugin
export default {"titleM":"index_titleM_ARasr","titImg":"index_titImg_863SD","titText":"index_titText_kJMrg","title":"index_title_i5SuT","date":"index_date_0l5LW","fz30":"index_fz30_oZvYO"};